
<div class="list">
  <div class="title">
    <h4 [translate]="'references.Title'"></h4>
  </div>
  <div id="rectColor"></div>

  <div class="tab">
    <div *ngFor="let ref of variants" class="reference" (click)="SelectReference(ref)">
      <div class="top">
        <span class="code">{{ref.code}} - {{ref.designation}}</span>
        <span class="date">{{ref.dateFrom}} <i aria-hidden="true" class="fas fa-arrow-right"></i>{{ref.dateTo}}</span>
      </div>
      <div class="bottom">
        <!--<span class="formuleNum">{{'references.FormuleNum'|translate}} : {{ref.formuleNum}}</span>-->
        <span *ngIf="ref.shadeGuideNum" class="shadeGuideNum">{{'references.ShadeGuideNum'|translate}} : {{ref.shadeGuideNum}}</span>
        <span class="technology"><span class="d-inline-flex flex-column justify-content-center align-items-center" style="font-size: .75em; line-height: 1em;"><span>{{ref.popularite}}%</span><img class="m-0" src="assets/img/ranking.svg" alt="{{'details.popularite'|translate}}"/></span> - {{ref.technology}} - {{ref.ssCouche}}</span>
      </div>
    </div>
  </div>
  <div class="tablist">
    <table mat-table [dataSource]="sortedResults"> <!--matSort (matSortChange)="sortReferences($event)">-->

      <ng-container matColumnDef="manufacturer">
        <th mat-header-cell *matHeaderCellDef (click)="multiSortManuel('manufacturer');">
          {{'common.manufacturer'|translate}}
          <i *ngIf="checkIfArrowUp('manufacturer')" class="fal fa-arrow-up arrowTriManuel"></i>
          <i *ngIf="checkIfArrowDown('manufacturer')" class="fal fa-arrow-down arrowTriManuel"></i>
          <span *ngIf="checkPositionArray('manufacturer') > -1">{{checkPositionArray('manufacturer') + 1}}</span>
        </th>
        <td mat-cell class="left" *matCellDef="let res"><img class="logo" src="assets/Logo/low/{{res.logoName.replace('.BMP','.png')}}" alt="" />{{res.manufacturer}}</td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef (click)="multiSortManuel('code');">
          {{'common.code'|translate}}
          <i *ngIf="checkIfArrowUp('code')" class="fal fa-arrow-up arrowTriManuel"></i>
          <i *ngIf="checkIfArrowDown('code')" class="fal fa-arrow-down arrowTriManuel"></i>
          <span *ngIf="checkPositionArray('code') > -1">{{checkPositionArray('code') + 1}}</span>
        </th>
        <td mat-cell *matCellDef="let res">{{res.code}}</td>
      </ng-container>

      <ng-container matColumnDef="designation">
        <th mat-header-cell *matHeaderCellDef (click)="multiSortManuel('designation');">
          {{'common.designation'|translate}}
          <i *ngIf="checkIfArrowUp('designation')" class="fal fa-arrow-up arrowTriManuel"></i>
          <i *ngIf="checkIfArrowDown('designation')" class="fal fa-arrow-down arrowTriManuel"></i>
          <span *ngIf="checkPositionArray('designation') > -1">{{checkPositionArray('designation') + 1}}</span>
        </th>
        <td mat-cell *matCellDef="let res" class="left">{{res.designation}}</td>
      </ng-container>

      <ng-container matColumnDef="dateFrom">
        <th mat-header-cell *matHeaderCellDef (click)="multiSortManuel('dateFrom');">
          {{'common.from'|translate}}
          <i *ngIf="checkIfArrowUp('dateFrom')" class="fal fa-arrow-up arrowTriManuel"></i>
          <i *ngIf="checkIfArrowDown('dateFrom')" class="fal fa-arrow-down arrowTriManuel"></i>
          <span *ngIf="checkPositionArray('manufacturer') > -1">{{checkPositionArray('manufacturer') + 1}}</span>
        </th><!-- [mat-sort-header]="dateFrom" -->
        <td mat-cell *matCellDef="let res">{{res.dateFrom}}</td>
      </ng-container>

      <ng-container matColumnDef="dateTo">
        <th mat-header-cell *matHeaderCellDef (click)="multiSortManuel('dateTo');">
          {{'common.to'|translate}}
          <i *ngIf="checkIfArrowUp('dateTo')" class="fal fa-arrow-up arrowTriManuel"></i>
          <i *ngIf="checkIfArrowDown('dateTo')" class="fal fa-arrow-down arrowTriManuel"></i>
          <span *ngIf="checkPositionArray('dateTo') > -1">{{checkPositionArray('dateTo') + 1}}</span>
        </th>
        <td mat-cell *matCellDef="let res">{{res.dateTo}}</td>
      </ng-container>

      <ng-container matColumnDef="shader">
        <th mat-header-cell *matHeaderCellDef (click)="multiSortManuel('shadeGuideNum');">
          {{'references.ShadeGuideNum'|translate}}
          <i *ngIf="checkIfArrowUp('shadeGuideNum')" class="fal fa-arrow-up arrowTriManuel"></i>
          <i *ngIf="checkIfArrowDown('shadeGuideNum')" class="fal fa-arrow-down arrowTriManuel"></i>
          <span *ngIf="checkPositionArray('shadeGuideNum') > -1">{{checkPositionArray('shadeGuideNum') + 1}}</span>
        </th>
        <td mat-cell *matCellDef="let res">{{res.shadeGuideNum}}</td>
      </ng-container>

      <ng-container matColumnDef="techno">
        <th mat-header-cell *matHeaderCellDef (click)="multiSortManuel('technology');">
          {{'details.techno'|translate}}
          <i *ngIf="checkIfArrowUp('technology')" class="fal fa-arrow-up arrowTriManuel"></i>
          <i *ngIf="checkIfArrowDown('technology')" class="fal fa-arrow-down arrowTriManuel"></i>
          <span *ngIf="checkPositionArray('technology') > -1">{{checkPositionArray('technology') + 1}}</span>
        </th>
        <td mat-cell *matCellDef="let res">{{res.technology}}</td>
      </ng-container>

      <ng-container matColumnDef="popularite">
        <th mat-header-cell *matHeaderCellDef (click)="multiSortManuel('popularite');">
          {{'details.popularite'|translate}}
          <i class="fal fa-lg fa-question-circle infoPopularite" matTooltip="Popularité donné à titre indicatif."></i>
          <i *ngIf="checkIfArrowUp('popularite')" class="fal fa-arrow-up arrowTriManuel"></i>
          <i *ngIf="checkIfArrowDown('popularite')" class="fal fa-arrow-down arrowTriManuel"></i>
          <span *ngIf="checkPositionArray('popularite') > -1">{{checkPositionArray('popularite') + 1}}</span>
        </th>
        <td mat-cell *matCellDef="let res">{{res.popularite}}</td>
      </ng-container>

      <ng-container matColumnDef="ssCouche">
        <th mat-header-cell *matHeaderCellDef (click)="multiSortManuel('ssCouche');">
          <i *ngIf="checkIfArrowUp('ssCouche')" class="fal fa-arrow-up arrowTriManuel"></i>
          <i *ngIf="checkIfArrowDown('ssCouche')" class="fal fa-arrow-down arrowTriManuel"></i>
          <span *ngIf="checkPositionArray('ssCouche') > -1">{{checkPositionArray('ssCouche') + 1}}</span>
        </th>
        <td mat-cell *matCellDef="let res">{{res.ssCouche}}</td>
      </ng-container>

      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef (click)="multiSortManuel('region');">
          {{ 'references.Region' | translate }}
          <i *ngIf="checkIfArrowUp('region')" class="fal fa-arrow-up arrowTriManuel"></i>
          <i *ngIf="checkIfArrowDown('region')" class="fal fa-arrow-down arrowTriManuel"></i>
          <span *ngIf="checkPositionArray('region') > -1">{{checkPositionArray('region') + 1}}</span>
        </th>
        <td mat-cell *matCellDef="let res">{{res.region}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>

      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="SelectReference(row)"></tr>
    </table>
  </div>
</div>
